import { render, staticRenderFns } from "./Bankkbankonly.vue?vue&type=template&id=889e4f5e"
import script from "./Bankkbankonly.vue?vue&type=script&lang=js"
export * from "./Bankkbankonly.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports